import React, { createContext, ReactNode, useEffect, useRef } from 'react';
import webStorage, { LOCAL_STORAGE_KEYS } from '@/core/web-storage/webStorage';
import { getSessionActivityTimestamp } from '@/core/web-storage/webStorage.utils';
import useLogout from '@/hooks/useLogout';

const TimeoutContext = createContext(undefined);
const TIMEOUT_DURATION = 900000;

export function TimeoutProvider({ children }: { children: ReactNode }) {
  const timeoutRef = useRef<NodeJS.Timeout>();
  const logout = useLogout();

  useEffect(() => {
    const handleWindowEvents = () => {
      clearTimeout(timeoutRef.current);
      webStorage.local.setItem(
        LOCAL_STORAGE_KEYS.SESSION_ACTIVITY_TIMESTAMP,
        new Date().toString(),
      );

      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(async () => {
        const nowTimestamp = new Date().valueOf();
        const latestSessionActivityTimestamp = getSessionActivityTimestamp().valueOf();

        if (Math.abs(nowTimestamp - latestSessionActivityTimestamp) > TIMEOUT_DURATION) {
          void logout();
        }
      }, TIMEOUT_DURATION);
    };

    window.addEventListener('mousemove', handleWindowEvents);
    window.addEventListener('keydown', handleWindowEvents);
    window.addEventListener('click', handleWindowEvents);
    window.addEventListener('scroll', handleWindowEvents);

    handleWindowEvents();

    return () => {
      window.removeEventListener('mousemove', handleWindowEvents);
      window.removeEventListener('keydown', handleWindowEvents);
      window.removeEventListener('click', handleWindowEvents);
      window.removeEventListener('scroll', handleWindowEvents);
    };
  }, []);

  return <TimeoutContext.Provider value={undefined}>{children}</TimeoutContext.Provider>;
}
